// Utility function to optimize Cloudinary image URLs
export const getOptimizedImageUrl = (cloudinaryUrl, options = {}) => {
  const {
    width = 'auto',
    height = 'auto',
    quality = 'auto',
    format = 'auto'
  } = options;

  // If it's already a Cloudinary URL, optimize it
  if (cloudinaryUrl && cloudinaryUrl.includes('cloudinary.com')) {
    try {
      const parts = cloudinaryUrl.split('/upload/');
      if (parts.length === 2) {
        const baseUrl = parts[0];
        const imagePath = parts[1];
        
        return `${baseUrl}/upload/f_${format},q_${quality},w_${width},h_${height},fl_progressive/${imagePath}`;
      }
    } catch (error) {
      console.warn('Error optimizing Cloudinary URL:', error);
    }
  }
  
  return cloudinaryUrl || '';
};

// Preload critical images
export const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    if (!src) {
      resolve();
      return;
    }
    
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
    img.src = src;
  });
}; 